import React from 'react';
import { Tabs, Tab } from '@mui/material';

function SalesTabs({ activeTab, onTabChange }) {
  return (
    <Tabs
      value={activeTab}
      onChange={onTabChange}
      sx={{ 
        borderBottom: 1, 
        borderColor: 'divider',
        mb: 0.5,
        minHeight: 36,
        '& .MuiTab-root': {
          textTransform: 'none',
          fontWeight: 500,
          minWidth: 120,
          py: 0.5,
          minHeight: 36,
        }
      }}
    >
      <Tab label="All Invoices" />
      <Tab label="Draft Invoices" />
    </Tabs>
  );
}

export default React.memo(SalesTabs); 